module.exports = __webpack_public_path__ + "static/media/img_faceassessmenton_1_3rule.8f8c38f2.jpg";